module.exports = __webpack_public_path__ + "static/media/63.36635166.png";